import { put, call, take, fork } from 'redux-saga/effects'
import { deleteCollectionInvitationService } from 'src/api/collection'

import generalSaga from '../general'
import { operationSuccess, operationFail } from 'src/reducers/operation/action'
import { DELETE_COLLECTION_INVITATION } from 'src/reducers/collection/type'
import { deleteCollectionInvitationSuccess } from 'src/reducers/collection/action'
/**
 *
 * @param {*} payload
 */
function* deleteCollectionInvitationSagaFlow(payload) {
  try {
    const { id, email, callback } = payload
    yield call(deleteCollectionInvitationService, id, email)

    yield put(deleteCollectionInvitationSuccess(email))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* deleteCollectionInvitationWatcher() {
  while (true) {
    const action = yield take(DELETE_COLLECTION_INVITATION)
    const { payload } = action

    yield fork(generalSaga, deleteCollectionInvitationSagaFlow, payload)
  }
}
